import React from 'react';
import { Switch, Typography } from 'antd';
import cn from 'classnames';
import styles from './PriorityFirstSwitch.module.scss';

const PriorityFirstSwitch = ({
  wrapClassName,
  checked,
  onClick,
  switchSize = 'small',
  content,
}) => {
  return (
    <div
      className={cn(styles.root, wrapClassName)}
      onClick={() => onClick(!checked)}
    >
      <Switch checked={checked} size={switchSize} />
      {Boolean(content) && <Typography.Text>{content}</Typography.Text>}
    </div>
  );
};

export default PriorityFirstSwitch;
